// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"138":"d6fea4c3","167":"af6292d2","925":"5b75e960","953":"ada2d9a6"}[chunkId] + ".css";
};